<template>
  <div class="toast-updated">
    <div>{{ t("messages.newVersionInstalled") }}</div>
    <a
      class="toast-updated__link"
      :href="`https://support.simcision.com/changelog-${changelogLocale}/#changelog`"
      target="_blank"
    >
      {{ t("labels.viewChangelog") }}
    </a>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { i18n } from "@/i18n";

defineProps<{
  toastId?: number | null | object;
}>();
defineEmits<{
  (e: "close-toast", toastId: number): void;
}>();

// The changelog is only available in English and German.
const changelogLocale = computed(() => {
  if (i18n.locale.value == "de") return "de";
  return "en";
});

const t = i18n.t;
</script>

<style lang="scss">
.toast-updated {
  display: flex;
  flex-direction: row;
  gap: 0.5em;
  align-items: center;
  &__link {
    background-color: var(--color-background-deep);
    padding: 0.3em 0.75em;
    border-radius: 2px;

    transition: box-shadow 250ms;

    &:hover {
      box-shadow: 0 2px 10px var(--color-shadow-2);
    }
  }
}
</style>
